import React from "react";

interface ErrorIconProps {
  className?: string;
  width?: number;
  height?: number;
}

const ErrorIcon: React.FC<ErrorIconProps> = ({ className, width = 24, height = 24 }) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="12" cy="12" r="10" fill="#D32F2F"/>
      <path 
        d="M12 7V13M12 16H12.01" 
        stroke="white" 
        strokeWidth="2" 
        strokeLinecap="round"
      />
    </svg>
  );
};

export default ErrorIcon;
